var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-page wap"},[_c('Header'),_c('Banner'),_c('Carousel',{attrs:{"isSelf":true}}),_c('div',{staticClass:"m-wap-page page-bottom"},[_c('List')],1),(_vm.extraItem.extras('copyright.display'))?_c('div',{staticClass:"m-copyright",style:({
      textAlign: _vm.extraItem.extras('copyright.position'),
      color: _vm.extraItem.extras('copyright.color'),
      fontSize:
        _vm.extraItem.extras('copyright.fontSize') === 'big'
          ? _vm.pxOrVw(28)
          : _vm.extraItem.extras('copyright.fontSize') === 'small'
          ? _vm.pxOrVw(20)
          : _vm.pxOrVw(24),
      fontWeight:
        _vm.extraItem.extras('copyright.bold') === 'bold' ? 'bold' : 'normal',
      fontStyle:
        _vm.extraItem.extras('copyright.italic') === 'italic'
          ? 'italic'
          : 'normal',
      whiteSpace: 'pre-line',
      paddingBottom: _vm.pxOrVw(30)
    })},[_vm._v(" "+_vm._s(_vm.extraItem.extras("copyright.model"))+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }